<template>
    <div class="agent-page">
        <div style="display: flex; flex-direction: column; text-align: start;">
            <h2 class="page-title" style="font-size: 15px;">{{ projectTitle }}</h2>
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h2 class="page-title" style="margin-top: 10px;">下载招标文件</h2>
                <el-button type="primary" icon="el-icon-arrow-left" size="small"
                    @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 表格内容 -->
        <div class="content-wrap">
            <el-table :data="tableData" border style="width: 100%" class="tender-table">
                <el-table-column prop="no" label="NO." width="80" align="center"></el-table-column>
                <el-table-column prop="documentNumber" label="招标文件编号" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="documentName" label="招标文件名称" min-width="200"
                    show-overflow-tooltip></el-table-column>
                <el-table-column prop="documentType" label="文件类型" width="120" align="center"></el-table-column>
                <el-table-column prop="submissionDeadline" label="投标文件递交截至时间" width="200"
                    align="center"></el-table-column>
                <el-table-column prop="openingTime" label="开标时间" width="200" align="center"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDownload(scope.row)" class="download-btn">下载文件</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'
export default {
    name: 'DownloadTender',
    data() {
        return {
            sectionCode: this.$route.query.sectionCode || '',   // 获取项目编号
            projectTitle: '',
            tableData: [
                {
                    no: 1,
                    documentNumber: 'ZC1101050893002183001Z01',
                    documentName: '251015公开招标标段1',
                    documentType: '招标文件',
                    submissionDeadline: '2025-10-16 00:00:00',
                    openingTime: '2025-10-16 00:00:00'
                }
            ],
            currentPage: 1,
            pageSize: 10,
            total: 1
        }
    },
    mounted() {
        this.getProjectInfo()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 下载文件
        handleDownload(row) {
            this.$message.success(`开始下载文件：${row.documentName}`)
            // 这里实现具体的下载逻辑
        },
        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.loadData()
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.loadData()
        },
        // 加载数据
        loadData() {
            // 这里实现数据加载逻辑
            console.log(`加载第${this.currentPage}页，每页${this.pageSize}条`)
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/agent-common.css';

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.content-wrap {
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
    background: white;
}

.tender-table {
    .el-table__header {
        background-color: #f5f7fa;
    }

    .el-table__header th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
    }

    .download-btn {
        color: #409EFF;
        font-weight: 500;

        &:hover {
            color: #66b1ff;
        }
    }
}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}
</style>